import React from "react";
import styled from "styled-components";


export default styled.img`
    max-width: 330px;
    width: 95%;
    margin: 25px auto 15px;
    display: block;
    margin: 0 50px -1px;
    max-width: 260px;
    margin-top: 50px;
`;